<input
  type="button"
  class="btn"
  [ngClass]="primaryButtonSetting.className"
  [id]="primaryButtonSetting.idName"
  [value]="primaryButtonSetting.label"
  (focus)="onFocusEvent($event)"
  (click)="onClickEvent()"
  (blur)="onBlurEvent($event)"
/>
<h2 *ngIf="hasPressEnter" class="press">
  Press <span class="enter">Enter</span>
</h2>
